import { IEntity, IEntityStore } from '../../main/entities';
import { IOcResponse } from '../../services/Communicator';

export class DelegateRepo<E extends IEntity> implements IEntityStore<E> {
	constructor(protected readonly delegate: IEntityStore<E>) {
	}

	readonly id = this.delegate.id; //TODO

	get etag() {
		return this.delegate.etag;
	}

	get length() {
		return this.delegate.length;
	}

	get allAsList() {
		return this.delegate.allAsList;
	}

	readonly upserter = this.delegate.upserter;

	readonly clear = this.delegate.clear.bind(this.delegate);

	readonly byId = this.delegate.byId.bind(this.delegate);

	readonly fetch = this.delegate.fetch.bind(this.delegate);

	readonly fetchDirect = this.delegate.fetchDirect.bind(this.delegate); //TODO remove

	readonly handleResponse = (responsePromise: Promise<IOcResponse>, successMessage: string) =>
		this.delegate.handleResponse(responsePromise, successMessage);
}
